import { memo } from 'react';

import styles from './styles.module.less';

function MenuIcon({ iconName }) {
  return (
    <div aria-hidden className={styles.icon}>
      <span className="material-symbols-outlined">{iconName}</span>
    </div>
  );
}

export default memo(MenuIcon);
